import { Component } from '@angular/core';

@Component({
  selector: 'fleet-reports',
  templateUrl: './fleetReport.Component.html'
})
export class FleetReportsComponent {
  constructor(){}
  ngOnInit(){}
}


// WEBPACK FOOTER //
// ./src/app/reports/fleet-report/fleetReport.component.ts